import React from "react";
import { Link } from "react-router-dom";
import {
  FaHome,
  FaTags,
  FaClipboardCheck,
  FaFileAlt,
  FaCogs,
  FaBars,
  FaTimes,
} from "react-icons/fa";

const Sidebar = ({
  isCollapsed,
  isMobile,
  onToggleCollapse,
  onToggleMobileMenu,
}) => {
  return (
    <aside
      className={`${
        isCollapsed ? "w-16" : "w-64"
      } bg-white text-gray-800 shadow-md h-screen p-4 transition-all duration-300 ${
        isMobile ? "fixed inset-0 z-50" : ""
      }`}
    >
      {/* Sidebar Header */}
      <div className="flex items-center justify-between mb-6">
        {!isCollapsed && (
          <h2 className="text-lg font-bold tracking-wide text-blue-600">
            Medicine Schedule
          </h2>
        )}
        <button
          onClick={onToggleCollapse}
          className="text-blue-600 hover:text-blue-800 sm:display-none"
        >
          {isCollapsed ? <FaBars size={20} /> : <FaTimes size={20} />}
        </button>
      </div>

      {/* Navigation Links */}
      <nav>
        <ul className="space-y-4">
          <li>
            <Link
              to="/new/setup/medicine-schedules"
              className={`flex items-center ${
                isCollapsed ? "justify-center" : "gap-4"
              } mt-5 text-gray-700 hover:text-blue-600 hover:bg-gray-100 rounded-lg transition-all`}
            >
              <FaHome size={24} className="text-blue-500" />
              {!isCollapsed && (
                <span className="text-sm font-medium">Dashboard</span>
              )}
            </Link>
          </li>
          <li>
            <Link
              to="/new/setup/medicine-schedules/schedule-tagging"
              className={`flex items-center ${
                isCollapsed ? "justify-center" : "gap-4"
              } mt-5 text-gray-700 hover:text-blue-600 hover:bg-gray-100 rounded-lg transition-all`}
            >
              <FaTags size={24} className="text-blue-500" />
              {!isCollapsed && (
                <span className="text-sm font-medium">Schedule Tagging</span>
              )}
            </Link>
          </li>
          <li>
            <Link
              to="/new/setup/medicine-schedules/compliance-tracking"
              className={`flex items-center ${
                isCollapsed ? "justify-center" : "gap-4"
              } mt-5 text-gray-700 hover:text-blue-600 hover:bg-gray-100 rounded-lg transition-all`}
            >
              <FaClipboardCheck size={24} className="text-blue-500" />
              {!isCollapsed && (
                <span className="text-sm font-medium">Compliance Tracking</span>
              )}
            </Link>
          </li>
          <li>
            <Link
              to="/new/setup/medicine-schedules/reports"
              className={`flex items-center ${
                isCollapsed ? "justify-center" : "gap-4"
              } mt-5 text-gray-700 hover:text-blue-600 hover:bg-gray-100 rounded-lg transition-all`}
            >
              <FaFileAlt size={24} className="text-blue-500" />
              {!isCollapsed && (
                <span className="text-sm font-medium">Reports</span>
              )}
            </Link>
          </li>
          <li>
            <Link
              to="/new/setup/medicine-schedules/integration"
              className={`flex items-center ${
                isCollapsed ? "justify-center" : "gap-4"
              } mt-5 text-gray-700 hover:text-blue-600 hover:bg-gray-100 rounded-lg transition-all`}
            >
              <FaCogs size={24} className="text-blue-500" />
              {!isCollapsed && (
                <span className="text-sm font-medium">
                  Integration Guidelines
                </span>
              )}
            </Link>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
